const desktop = theme => {
  const {toVW} = theme;
  return {};
};

const mobile = theme => {
  const {toVW} = theme;
  const iconWidth = 35;
  const iconRatio = 0.875;

  return {
    title: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '8px',
      '& h5': {
        margin: 0,
        color: theme.textColor,
        fontSize: '14px',
      },
    },
    container: {
      padding: '20px',
      paddingTop: 0,
      display: 'flex',
      flexDirection: 'column',
      height: '450px',
      justifyContent: 'space-between',
    },
    header: {
      textAlign: 'center',
      marginBottom: '24px',
      '& h1': {
        margin: 0,
        fontSize: '24px',
        color: theme.textColor,
      },
    },
    topSection: {
      display: 'flex',
      flexDirection: 'column',
      rowGap: '15px',
      alignItems: 'center',
    },
    bottomSection: {
      display: 'flex',
      flexDirection: 'column',
      rowGap: '15px',
      borderTop: `1px solid rgba(255, 255, 255, 0.1)`,
      paddingTop: '15px',
    },
    closeButton: {
      margin: '0px !important',
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
